import { zakelijkProfielCodes } from "features/option-controls/door-width-controls/ZakelijkHelper";
import { ConfigurationPricingFooter } from "./ConfigurationPricingFooter";
import { ConfigurationPricingFooterProfiel } from "./ConfigurationPricingFooterProfiel";

export const ZakelijkPriceDetails = ({
  selectedDoorCode,
}: {
  selectedDoorCode?: string;
}) => {
  if (zakelijkProfielCodes.includes(selectedDoorCode ?? "")) {
    return <ConfigurationPricingFooterProfiel />;
  }
  return (
    <>
      {/* Configuration pricing */}
      <ConfigurationPricingFooter />
    </>
  );
};
